import { useAuth0 } from '@auth0/auth0-react';

export interface CheckoutItem {
  type: 'market' | 'neighborhood' | 'office';
  id: number;
}

export function useCheckout() {
  const { getAccessTokenSilently } = useAuth0();

  const startCheckout = async (items: CheckoutItem[]) => {
    const token = await getAccessTokenSilently({
      authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE }
    });

    const response = await fetch(`${process.env.REACT_APP_API_URL ?? ''}/api/checkout/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) throw new Error('Failed to create checkout session');

    const { url } = await response.json();
    window.location.href = url;
  };

  return { startCheckout };
}
